// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./StoreBranding.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-sans: 'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  --color-primary: #0d6efd;
  --color-primary-hover: #0a58ca;
  --color-bg: #f8f9fa;
  --color-text: #212529;
  --color-dark: #343a40;
  --max-width: 1200px;
  --border-radius: 8px;
  --transition-fast: 0.3s;
  --table-sticky-header-top: var(--app-shell-top-offset, 0px);
  --table-sticky-header-bg: #fff;
}

body {
  margin: 0;
  font-family: 'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  font-family: var(--font-sans);
  background-color: #f8f9fa;
  background-color: var(--color-bg);
  color: #212529;
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  scroll-behavior: smooth;
}

a {
  color: #0d6efd;
  color: var(--color-primary);
}

a:hover {
  color: #0a58ca;
  color: var(--color-primary-hover);
}

table thead th {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  top: var(--table-sticky-header-top, 0px);
  z-index: 2;
  background: #fff;
  background: var(--table-sticky-header-bg, #fff);
  background-clip: padding-box;
}

/* Generic content wrapper */
.nibbly-container {
  padding: 0 1rem;
  box-sizing: border-box;
}

.page-loading {
  --page-loading-bg: #f7f3ec;
  --page-loading-surface: #ffffff;
  --page-loading-text: #172119;
  --page-loading-muted: #6f6a60;
  --page-loading-border: #e7dccc;
  --page-loading-primary: #214734;
  --page-loading-primary-strong: #173326;
  --page-loading-accent: #c89a3c;
  --page-loading-shadow: 0 22px 60px rgba(47, 39, 29, 0.12);
  --page-loading-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --page-loading-font-display: Georgia, "Times New Roman", serif;
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 100vh;
  width: 100vw;
  padding: 2rem;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0) 420px),
    linear-gradient(180deg, rgba(238, 231, 220, 0.86), rgba(250, 248, 244, 0.8) 430px),
    var(--page-loading-bg);
  color: var(--page-loading-text);
  font-family: var(--page-loading-font-sans);
  text-align: center;
  z-index: 9999;
}

.page-loading__panel {
  width: min(100%, 460px);
  border: 1px solid var(--page-loading-border);
  border-radius: 8px;
  background: var(--page-loading-surface);
  box-shadow: var(--page-loading-shadow);
  padding: 28px;
}

.page-loading__eyebrow {
  margin: 0 0 8px;
  color: var(--page-loading-accent);
  font-size: 0.78rem;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

.page-loading__title {
  margin: 0 0 18px;
  color: var(--page-loading-text);
  font-family: var(--page-loading-font-display);
  font-size: clamp(1.35rem, 2.5vw, 1.7rem);
  font-weight: 750;
  line-height: 1.18;
}

.page-loading__button {
  -webkit-appearance: none;
          appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  min-width: 120px;
  border: 0;
  border-radius: 6px;
  padding: 11px 16px;
  background: var(--page-loading-primary);
  color: #fff;
  box-shadow: 0 12px 22px rgba(33, 71, 52, 0.22);
  font-family: var(--page-loading-font-sans);
  font-size: 1rem;
  font-weight: 850;
  line-height: 1.2;
  cursor: pointer;
  transition: transform 0.05s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.page-loading__button:hover,
.page-loading__button:focus-visible {
  background: var(--page-loading-primary-strong);
}

.page-loading__button:active {
  transform: translateY(1px);
}

.page-loading__button:focus-visible {
  outline: 2px solid rgba(33, 71, 52, 0.18);
  outline-offset: 3px;
}

@media (max-width: 560px) {
  .page-loading {
    padding: 16px;
  }

  .page-loading__panel {
    padding: 22px;
  }

  .page-loading__button {
    width: 100%;
  }
}

@media print {
  body {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAGA;EACE,+EAA+E;EAC/E,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,+EAA6B;EAA7B,6BAA6B;EAC7B,yBAAiC;EAAjC,iCAAiC;EACjC,cAAwB;EAAxB,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,QAAwC;EAAxC,wCAAwC;EACxC,UAAU;EACV,gBAA+C;EAA/C,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;EAC9B,yDAAyD;EACzD,mFAAmF;EACnF,8DAA8D;EAC9D,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB;;;0BAGwB;EACxB,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,uCAAuC;EACvC,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,6CAA6C;EAC7C,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAgB;UAAhB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,8CAA8C;EAC9C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');\n@import \"./StoreBranding.css\";\n\n:root {\n  --font-sans: 'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n  --color-primary: #0d6efd;\n  --color-primary-hover: #0a58ca;\n  --color-bg: #f8f9fa;\n  --color-text: #212529;\n  --color-dark: #343a40;\n  --max-width: 1200px;\n  --border-radius: 8px;\n  --transition-fast: 0.3s;\n  --table-sticky-header-top: var(--app-shell-top-offset, 0px);\n  --table-sticky-header-bg: #fff;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\na {\n  color: var(--color-primary);\n}\n\na:hover {\n  color: var(--color-primary-hover);\n}\n\ntable thead th {\n  position: sticky;\n  top: var(--table-sticky-header-top, 0px);\n  z-index: 2;\n  background: var(--table-sticky-header-bg, #fff);\n  background-clip: padding-box;\n}\n\n/* Generic content wrapper */\n.nibbly-container {\n  padding: 0 1rem;\n  box-sizing: border-box;\n}\n\n.page-loading {\n  --page-loading-bg: #f7f3ec;\n  --page-loading-surface: #ffffff;\n  --page-loading-text: #172119;\n  --page-loading-muted: #6f6a60;\n  --page-loading-border: #e7dccc;\n  --page-loading-primary: #214734;\n  --page-loading-primary-strong: #173326;\n  --page-loading-accent: #c89a3c;\n  --page-loading-shadow: 0 22px 60px rgba(47, 39, 29, 0.12);\n  --page-loading-font-sans: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  --page-loading-font-display: Georgia, \"Times New Roman\", serif;\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-height: 100vh;\n  width: 100vw;\n  padding: 2rem;\n  box-sizing: border-box;\n  background:\n    radial-gradient(circle at 50% 0, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0) 420px),\n    linear-gradient(180deg, rgba(238, 231, 220, 0.86), rgba(250, 248, 244, 0.8) 430px),\n    var(--page-loading-bg);\n  color: var(--page-loading-text);\n  font-family: var(--page-loading-font-sans);\n  text-align: center;\n  z-index: 9999;\n}\n\n.page-loading__panel {\n  width: min(100%, 460px);\n  border: 1px solid var(--page-loading-border);\n  border-radius: 8px;\n  background: var(--page-loading-surface);\n  box-shadow: var(--page-loading-shadow);\n  padding: 28px;\n}\n\n.page-loading__eyebrow {\n  margin: 0 0 8px;\n  color: var(--page-loading-accent);\n  font-size: 0.78rem;\n  font-weight: 850;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.page-loading__title {\n  margin: 0 0 18px;\n  color: var(--page-loading-text);\n  font-family: var(--page-loading-font-display);\n  font-size: clamp(1.35rem, 2.5vw, 1.7rem);\n  font-weight: 750;\n  line-height: 1.18;\n}\n\n.page-loading__button {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 46px;\n  min-width: 120px;\n  border: 0;\n  border-radius: 6px;\n  padding: 11px 16px;\n  background: var(--page-loading-primary);\n  color: #fff;\n  box-shadow: 0 12px 22px rgba(33, 71, 52, 0.22);\n  font-family: var(--page-loading-font-sans);\n  font-size: 1rem;\n  font-weight: 850;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: transform 0.05s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.page-loading__button:hover,\n.page-loading__button:focus-visible {\n  background: var(--page-loading-primary-strong);\n}\n\n.page-loading__button:active {\n  transform: translateY(1px);\n}\n\n.page-loading__button:focus-visible {\n  outline: 2px solid rgba(33, 71, 52, 0.18);\n  outline-offset: 3px;\n}\n\n@media (max-width: 560px) {\n  .page-loading {\n    padding: 16px;\n  }\n\n  .page-loading__panel {\n    padding: 22px;\n  }\n\n  .page-loading__button {\n    width: 100%;\n  }\n}\n\n@media print {\n  body {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
